import { FORM_SESSION_KEY } from '@resources/js/components/form/formStoreSync';
const getSessionFormData = () => {
    try {
        return JSON.parse(sessionStorage.getItem(FORM_SESSION_KEY) || '{}');
    }
    catch (_a) {
        return {};
    }
};
export const generateBcomParamsFromSessionStorage = (type) => {
    const { checkIn, checkOut, adultsCount, childrenCount, children } = getSessionFormData();
    return {
        type,
        dates: checkIn && checkOut ? { checkIn, checkOut } : undefined,
        adultsCount,
        childrenCount,
        childrenAges: children === null || children === void 0 ? void 0 : children.filter(Boolean).map(c => c.age),
    };
};
